module.exports = __webpack_public_path__ + "img/22.207533ea.png";